module.exports = __webpack_public_path__ + "img/0.e2a36de7.jpg";